/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Review': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.571 2.142a.429.429 0 00-.428.429v8.571c0 .237.192.429.428.429h1.715c.236 0 .428.192.428.428v1.715l2.743-2.057a.428.428 0 01.257-.086h6a.429.429 0 00.429-.429V2.571a.429.429 0 00-.429-.429H2.571zm-1.285.429c0-.71.575-1.286 1.285-1.286h11.143c.71 0 1.286.576 1.286 1.286v8.571c0 .71-.576 1.286-1.286 1.286H7.857l-3.314 2.486a.429.429 0 01-.686-.343v-2.143H2.571c-.71 0-1.285-.576-1.285-1.286V2.571zm2.571 3c0-.237.192-.429.429-.429H12A.429.429 0 1112 6H4.286a.429.429 0 01-.429-.428zm.429 2.143a.429.429 0 100 .857h6a.429.429 0 100-.857h-6z" _fill="#CFCFCF"/>'
  }
})
